/* eslint-disable react/display-name */
/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 10/08/2020.
 * @module Root
 * @description Import all modules in system
 */

import React, { useEffect, useCallback } from "react";
import ModulesRoutes from "./modules.routes";
import { useSelector, useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { makeSelectIdentityByPath } from "app/modules/identity/_redux/selectors";
import { getMe } from "app/modules/identity/_redux/actions";
import {
  browseRepositories,
  browseAllStations,
  getAllMenu,
  getStrictedRoute,
  getAllStation,
  getAllHardWare,
  browseOwnStations,
  browseOwnCompanyStations,
  browseStationsV2,
} from "app/modules/app/_redux/actions";
import { dvrThunks } from "app/modules/camera/_redux/thunks";
import { cameraConfigByStationActions } from "./camera/_redux/reducer";
import ErrorBoundary from "./admin/components/ErrorBoundary";

const ModulesComponent = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) =>
    makeSelectIdentityByPath(state, ["isAuthenticated"])
  );
  const getAllDvrChannel = useCallback(async () => {
    const resultAction = await dispatch(dvrThunks.browseDvrChannelRequest());
    let dvrChannel = unwrapResult(resultAction);
    if (dvrChannel) {
      dispatch(cameraConfigByStationActions.dvrChannelBrowsed(dvrChannel));
    }
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getMe());
      dispatch(getAllMenu());
      dispatch(getAllStation());
      dispatch(getStrictedRoute());
      getAllDvrChannel().then((r) => r);
      dispatch(browseRepositories());
      dispatch(browseAllStations());
      dispatch(browseOwnStations());
      dispatch(browseOwnCompanyStations());
      dispatch(browseStationsV2());
    }
  }, [isAuthenticated]);
  return (
    <ErrorBoundary>
      <ModulesRoutes isAuthenticated={isAuthenticated} />
    </ErrorBoundary>
  );
};
export default ModulesComponent;
